<template>
    <div class="bg-default flex-x-center">
        <el-form ref="form" :model="form" :rules="rules" size="small" label-position="left" label-width="94px" class="formButtonRight mt-24" style="width: 500px">
            <idc-form-item :form="form" :config="formConfig" col="24" clearable>
                <el-button @click="$emit('cancel')">
                    取消
                </el-button>
                <el-button @click="submit" type="primary">
                    确定
                </el-button>
            </idc-form-item>
        </el-form>
    </div>
</template>

<script>
export default {
    data() {
        return {
            form: {},
            formConfig: [
                { itemType: 'input', prop: 'oldPassword', label: '旧密码：' },
                { itemType: 'input', prop: 'newPassword1', label: '新密码：' },
                { itemType: 'input', prop: 'newPassword2', label: '确认密码：' }
            ],
            rules: {
                oldPassword: [{ required: true, message: '请输入旧密码', trigger: 'blur' }],
                newPassword1: [{ required: true, message: '请输入新密码', trigger: 'blur' }],
                newPassword2: [{ required: true, message: '请输入确认密码', trigger: 'blur' }]
            }
        };
    },
    methods: {
        submit() {
            this.$refs.form.validate(valid => {
                if (!valid) return;
                if (this.form.newPassword1 !== this.form.newPassword2) {
                    this.$message({
                        message: '两次输入密码不一致',
                        type: 'warning'
                    });
                    return;
                }
                let params = {
                    oldPassword: this.form.oldPassword,
                    newPassword: this.form.newPassword1
                };
                this.$http.post(this.$service.personCenter.setPassword, params).then(res => {
                    if (res && res.message && res.message.indexOf('成功')) {
                        this.$message({
                            type: 'success',
                            message: res.message
                        });
                    } else {
                        this.$message({
                            type: 'warning',
                            message: res.message || '修改失败'
                        });
                    }
                    this.$emit('cancel');
                });
            });
        }
    }
};
</script>
